import { playSupportCue, type SupportCueKind } from '@srm/screen-sharing/light';

/** Выключатель «Звуки в сеансе поддержки» («Мои настройки» → «Доступ поддержки»): по умолчанию включено. */
export const SUPPORT_CUES_KEY = 'srm.screenShare.cues';

export function supportCuesEnabled(): boolean {
    try {
        return localStorage.getItem(SUPPORT_CUES_KEY) !== '0';
    } catch {
        return true;
    }
}

export function setSupportCuesEnabled(on: boolean): void {
    try {
        if (on) localStorage.removeItem(SUPPORT_CUES_KEY);
        else localStorage.setItem(SUPPORT_CUES_KEY, '0');
    } catch {
        /* Хранилище закрыто: выбор живёт до перезагрузки страницы. */
    }
}

/** Звук события показа, если пользователь их не выключил; без разблокированного звука пакет его пропустит. */
export function supportCue(kind: SupportCueKind): void {
    if (supportCuesEnabled()) playSupportCue(kind);
}
